import React from 'react';
import Colors from '../../constants/colors';
import { ReactComponent as LoadingSvg } from '../../assets/icons/loading.svg';

export const Loading = () => (
  <div style={{
    height: '100vh',
    width: '100vw',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: Colors.getBlueOxford(),
  }}
  >
    <LoadingSvg width={30} />
  </div>
);

export default {
  Loading,
};
